import script from "./UserProfileSelectorItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileSelectorItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__